module.exports = __webpack_public_path__ + "catalog/items/router-wifi/routerWifi.png";